var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4637 0.959961C9.38554 1.01038 6.45087 2.27014 4.29408 4.4668C2.1136 6.6377 0.909997 9.60217 0.96 12.6787C0.956424 15.6836 2.14897 18.5663 4.27435 20.6904C6.39974 22.8145 9.28315 24.0054 12.288 24H12.4934C18.9045 23.934 24.0522 18.6906 24 12.2793C24.0072 9.23718 22.7869 6.3208 20.6155 4.19031C18.4441 2.05969 15.5051 0.89502 12.4637 0.959961ZM11.04 16.8402C11.026 16.46 11.1656 16.0901 11.4272 15.8138C11.6888 15.5376 12.0506 15.3782 12.431 15.3715H12.457C13.2442 15.3729 13.8897 15.996 13.919 16.7827C13.9333 17.163 13.7938 17.533 13.5321 17.8093C13.2704 18.0857 12.9085 18.245 12.528 18.2515H12.5021C11.7153 18.2489 11.0704 17.6265 11.04 16.8402ZM11.52 7.19995V12.96C11.52 13.4902 11.9498 13.92 12.48 13.92C13.0102 13.92 13.44 13.4902 13.44 12.96V7.19995C13.44 6.6698 13.0102 6.23999 12.48 6.23999C11.9498 6.23999 11.52 6.6698 11.52 7.19995Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alertCircle.3db60dfc.svg";
export { ForwardRef as ReactComponent };